import { writable } from "svelte/store";
import type { Tile } from "../types/tile";

/** Our current name */
export const name = writable("");

/** The names of everyone in the server (including us), in the order we joined */
export const players = writable<string[]>([]);

/** The server name */
export const server = writable("");

/** The current player whose turn it is */
export const currentPlayer = writable("");

/** The map of players who are ready (used so other people can ready when we're on Lobby or Game) */
export const isReady = writable<Set<string>>(new Set());

/** Initial tiles of the game (used for the transition from Lobby to Game) */
export const initialTiles = writable<Tile[]>([]);

/** Flag whether we're on initial meld or not (used for transition) */
export const initialMeld = writable<boolean>(true);
